import { createAsyncThunk } from "@reduxjs/toolkit";
import CAxios from "../utils/CAxios";
import { AxiosResponse } from "axios";

export const toGetServices = createAsyncThunk<
  any,
  {
    tag: string;
    limit?: number;
    page?: number;
    date_to?: string;
    date_from?: string;
    assistance_id? : string;
  }
>(
  "services/toGetServices",
   async (data) =>{
    try {
      const response = await CAxios.post(`services` ,data);
      return response?.data?.result;
    } catch (error) {
      throw error;
    }
  }
);
/*--------------------------GET SERVICES REQUESTS-----------------------------*/
export const toGetServicesRequests = createAsyncThunk<
  any,
  {
    assistance_id?: number;
    limit?: number;
    page?: number;
  }
>("services/toGetServicesRequests", async (data) => {
  try {
    const response = await CAxios.post(`services/requests`, data);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});

export const toGetServicesBeneficiaries = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("services/toGetServicesBeneficiaries", async (serviceId: any) => {
  try {
    const response = await CAxios.post(`services/beneficiaries`, serviceId);
    return response;
  } catch (error) {
    throw error;
  }
});

export const toAddRequestBeneficiaries = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("services/toAddRequestBeneficiaries", async (data: any) => {
  try {
    const response = await CAxios.post(`services/application`, data);
    return response;
  } catch (error) {
    throw error;
  }
});

export const toGetServicesListRequests = createAsyncThunk<
  any,
  {
    limit?: number;
    page?: number;
    date_to?: string;
    date_from?: string;
    assistance_id?: any;
  }
>("services/toGetServicesListRequests", async (data) => {
  try {
    const response = await CAxios.post(`family/services/application`, data);
    return response?.data;
  } catch (error) {
    throw error;
  }
});


export const getBarCodeServicesRequests = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("sponsor/getBarCodeServicesRequests", async (id) => {
  try {
    let response = await CAxios.get(`service/application/barcode/print/${id}`, {
      responseType: "blob" as const,
    });
    return response;
  } catch (error) {
    throw error;
  }
});
export const addProcuration = createAsyncThunk<AxiosResponse<any, any>, any>(
  "services/addProcuration",
  async (procurationData: any) => {
    try {
      const response = await CAxios.post(`authorizations`, procurationData);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
